import { useOne, useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { Space, theme } from 'antd';
import type {
  PublicationListOut,
  TestimonialOut,
} from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { TestimonialActionButtons } from '@/components/feedback/TestimonialActionButtons';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { TESTIMONIAL_DEFAULT_TAB, TESTIMONIAL_SHOW_TABS } from '../constants';
import { TestimonialShowHeader } from './TestimonialShowHeader';
import { TestimonialGeneralTab } from './TestimonialGeneralTab';

export const TestimonialShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<TestimonialOut>({
    resource: 'feedback.testimonials',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle('feedback.testimonials', record?.author_name);

  const [activeTab, onTabChange] = useShowTab(
    TESTIMONIAL_SHOW_TABS,
    TESTIMONIAL_DEFAULT_TAB
  );

  const { result: publication } = useOne<PublicationListOut>({
    resource: 'user_catalog.publications',
    id: record?.publication_id ?? 0,
    queryOptions: { enabled: !!record?.publication_id },
  });

  return (
    <Show
      isLoading={isLoading}
      contentProps={bareShowContentProps}
      headerButtons={({ defaultButtons }) => (
        <Space>
          {defaultButtons}
          {record?.id && (
            <TestimonialActionButtons
              testimonialId={record.id}
              isPromoted={record.is_promoted}
            />
          )}
        </Space>
      )}
    >
      {record && (
        <>
          <TestimonialShowHeader
            record={record}
            publication={publication}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <TestimonialGeneralTab
                record={record}
                publication={publication}
              />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
